<template>
<div>
  <!-- <label class="typo__label" :for="'searchPax'+searchPaxReq">Search</label> -->
  <label  :for="'searchPax'+searchPaxReq"></label>
 
  
<!--                                                                :class="{normalWidth : }" -->
  <multiselect v-model="searchedName" :id="'searchPax'+paxIndex+searchPaxReq" :custom-label="customLabel"
  track-by="paxid"
  deselectLabel=""
        deselectGroupLabel=""
        selectLabel=""
        selectedLabel=""
   :placeholder="$t('passInfo.cSearchPax.typeToSearch')" open-direction="bottom"  :options="searchedPax" :multiple="false"
   :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false"  

   :close-on-select="true" :options-limit="300" :limit="3"   @select="onPaxSelected" 
   :max-height="600" :show-no-results="true" :showNoOptions="false" :hide-selected="false" @search-change="getSearchedPax">

  
     <template slot="tag" slot-scope="{ option, remove }">

       <span class="custom__tag"><span>{{ option.firstname }}</span>
       <span class="custom__remove" @click="remove(option)">❌</span></span>
       </template>
    <template slot="clear" slot-scope="props">
      
      <div class="multiselect__clear" v-if="searchedName" @mousedown.prevent.stop="clearAll(props.search)"></div>
      
    </template>
   <span slot="noResult"><strong>{{noResult}}</strong></span>
   <!-- <span slot="noOptions"></span> -->
   

    <span slot="option" slot-scope="props">
        <div class="opation-wrap">
<div class="name">
    {{props.option.title+' '+props.option.firstname+' '+props.option.lastname}}
</div>
            <div class="id">
                <!-- <div>{{props.option.doctype=='PP'?'Passport':'NRIC'}}</div> <span>({{props.option.docnumber}})</span> -->
                <img src="@imgPath/img/svg/icons/passport.svg" alt="">
<!--                <img src="https://image.flaticon.com/icons/svg/2405/2405593.svg" alt="">-->
<!--                <img src="https://image.flaticon.com/icons/svg/1086/1086563.svg" alt="">-->
<!--                <div>{{props.option.doctype}}</div> -->
                <span>{{props.option.docnumber}}</span>
            </div>
    </div></span>

    
  </multiselect>
  
  
</div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import apiSearchPassenger from "../../services/apiSearchPassenger.js";

import { mapGetters, mapActions } from "vuex";
import { PATHNAME, COMPONENT_NAME,DEFAULT_DROPDOWN_STATUS,PAX_TITLE } from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue, cloneData } from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
export default {
  name: COMPONENT_NAME.C_SEARCH_PAX,
  components: {
    ValidationProvider,
    Multiselect
  },
  model: {
    prop: "selValue"
  },

  props: {
    searchPaxReq: {
      type: String,
      default: null
    },
    paxIndex: {
      type:Number,
      default: null
    }
  },
   data: () => ({
     searchedName:null,
     searchedPax:[],
     noResult:null,
     isLoading: false,
        }),

  methods:{
    clearAll () {
      this.searchedName = null;
    },

    customLabel(option) {
      return `${option.title+' '+option.firstname+' '+option.lastname+' - '+option.doctype+' - '+option.docnumber} `;
    },

    

     onPaxSelected(selpaxObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onPaxSelected");

                    if (selpaxObj) {
                     this.searchedName=selpaxObj;
                     this.$emit("searchedPax",this.searchedName);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        onPaxSelected,
                        "error in onPaxSelected",
                        err.toString(),
                        "onPaxSelected",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


    async getSearchedPax(pSearched) {
      let returnValue=[];
     let searchPax=null;
    //  if(this.searchPaxReq=='CHD') {
    //    searchPax = 'ADT';
    //  }else{
       searchPax = this.searchPaxReq;
    //  }
      try {
        if (BaseConfiguration.isDebug) console.log("getSearchedPax "+pSearched);
        if(pSearched.length>=3){
      
        let searchPaxReq = apiSearchPassenger.buildRequest(searchPax,pSearched);
        if (searchPaxReq) {
          this.isLoading= true;
          let searchPaxRes = await apiSearchPassenger.getResponse(searchPaxReq);
          if (
            VALIDATE_SUCCESS_RES(searchPaxRes) 
          ) {
            //save res in store
            this.isLoading= false;
           
            this.searchedPax=searchPaxRes.data.data;
           returnValue = searchPaxRes.data.data;
           if(returnValue.length==0){
             this.noResult = this.$t('passInfo.cSearchPax.noMatchesFound');
           }
            
          } else {
            if(this.searchedPax.length!=0){
              this.searchedPax=[];
            }
            
            this.isLoading= false;
            let error = getErrorMessage(searchPaxRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          //  this.isLoading= false;
          throw "invalid request"; //
        }
      }else{
        if(this.searchedPax.length!=0){
              this.searchedPax=[];
            }
        this.noResult= this.$t('passInfo.cSearchPax.threeCharactersToSearch')
      }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_DROPDOWN,
          "getPaymentGroups",
          err.toString(),
          "getPaymentGroups",
          LOG_TYPE.ERROR
        );
      }

      return returnValue;
    },
  }
}
    </script>

